import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDraw: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconDraw"><Path d="M2 14.05C10.7509 5.35386 14.3051 1.943 16.3759 4.15545C19.2621 7.2387 4.43808 16.5967 8.53917 18.9727C11.9562 20.9508 17.4705 10.1582 19.7352 12.9262C21.0712 14.5575 16.3759 18.1729 17.6259 19.9718C18.6261 21.4108 20.9596 19.5715 22 18.4723" stroke="currentColor" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconDraw;
